import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '@app/services/commons/Loading.service';
import { Esg } from '@app/store/models/esg.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-esg',
    templateUrl: './esg.component.html',
    styleUrls: ['./esg.component.scss'],
    standalone: false
})
export class EsgComponent implements OnInit {

    response: Esg;

    constructor(
        private http: HttpClient,
        private router: Router,
        private translateService: TranslateService,
        private loadingService: LoadingService
    ) {}
  
    ngOnInit() {
      this.loadingService.show();
      this.http.get('https://rinnovofirma.infocert.it/esg').subscribe((res: Esg) => {
        this.response = res;
        console.log(this.response);
      }, (error) => {
        this.router.navigate(['/homepage']);
      });
      this.loadingService.hide();
    }

    openUrl() {
        window.open(
          this.translateService.instant('ESG.INNOVATION_CARD.URL'),
          '_blank'
        );
      }

}
